import FormattedMessage from 'I18n/components/FormattedMessage';
import { CreditTile } from './CreditTile';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CreditTileUsed = ({
  hasLowCredits,
  isLoading,
  totalUsage,
  usageLimit
}) => /*#__PURE__*/_jsxs(CreditTile, {
  isLoading: isLoading,
  children: [/*#__PURE__*/_jsx(CreditTile.Count, {
    hasLowCredits: hasLowCredits,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "enrichmentCredits.used",
      options: {
        totalUsage,
        usageLimit
      }
    })
  }), /*#__PURE__*/_jsx(CreditTile.Label, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "enrichmentCredits.usedLabel"
    })
  })]
});